module.exports = __webpack_public_path__ + "static/hero-cc7dc0bc6cc2a5582c1918383f9ab941.jpg";